import { FC } from 'react';
import { IYearDocuments } from '../types';
import MobileFinancialAnnualDocuments from './MobileFinancialAnnualDocuments';
import MobileFinancialQuarters from './MobileFinancialQuarters';

interface IProps {
  year: string;
  yearDocuments: IYearDocuments;
}

const MobileFinancialYearCalendar: FC<IProps> = ({ year, yearDocuments }) => {
  const {
    quarterly_filings,
    transcripts,
    earnings_presentation,
    annual_report,
    earnings_releases,
    proxy,
    proxy_supplement,
  } = yearDocuments;

  return (
    <>
      <div className="financial-results__table--mobile-years-row">
        <div className="montserrat-20-regular">{year}</div>
      </div>
      <MobileFinancialQuarters
        title="Earning releases"
        quarters={earnings_releases}
      />
      <MobileFinancialQuarters
        title="Earning presentation"
        quarters={earnings_presentation}
      />
      <MobileFinancialQuarters title="Transcripts" quarters={transcripts} />
      <MobileFinancialQuarters
        title="Quarterly filings"
        quarters={quarterly_filings}
      />
      <MobileFinancialAnnualDocuments
        title="Annual report"
        status={annual_report.annual_report_status}
        documents={{
          pdf: annual_report.pdf_annual_report,
          doc: annual_report.doc_annual_report,
          xls: annual_report.xls_annual_report,
        }}
      />
      <MobileFinancialAnnualDocuments
        title="Proxy"
        status={proxy.proxy_status}
        documents={{
          pdf: proxy.pdf_proxy,
          doc: proxy.doc_proxy,
          xls: proxy.xls_proxy,
        }}
      />
      <MobileFinancialAnnualDocuments
        title="Proxy supplement"
        status={proxy_supplement.proxy_supplement_status}
        documents={{
          pdf: proxy_supplement.pdf_proxy_supplement,
          doc: proxy_supplement.doc_proxy_supplement,
          xbrl: proxy_supplement.xbrl_proxy_supplement,
        }}
      />
    </>
  );
};

export default MobileFinancialYearCalendar;
